import { Field } from "react-final-form";
import cn from "classnames";

import styles from "./CheckboxField.module.scss";
import { ERROR_FIELD_ } from "~/configs/consts";

export const Checkbox = ({ disabled, styleIndicatorProps, checked, onChange, labelClassName, indicatorClassName, ...props }: any) => {
  const handleChange = () => {
    onChange(!checked);
  };

  return (
    <label
      className={cn(styles.checkbox, styles, labelClassName, {
        [styles.disabledLabel]: disabled
      })}
    >
      <input
        type="checkbox"
        {...props.input}
        id={props.id}
        disabled={disabled}
        checked={checked || props?.input?.checked}
        onChange={onChange ? handleChange : props.input.onChange}
      />
      <span className={cn(styles.indicator, indicatorClassName, {
        [styles.disabledLabel]: disabled
      })} style={styleIndicatorProps}></span>
      {props.children}
    </label>
  );
};

export const CheckboxField = ({
  fieldName,
  name,
  title,
  validate,
  disabled,
  styleIndicatorProps,
  checked,
  onChange
}: any) => (
  <Field
    name={fieldName}
    type="checkbox"
    value={name}
    validate={validate}
    subscription={{ error: true, submitError: true, submitFailed: true, value: true }}
  >
    {({ input, meta }) => {
      const hasError = (meta.error || meta.submitError) && meta.submitFailed;
      const inputId = hasError ? `${ERROR_FIELD_}${input.name}` : undefined;

      return (
        <Checkbox
          input={input}
          id={inputId}
          disabled={disabled}
          styleIndicatorProps={styleIndicatorProps}
          checked={checked}
          onChange={onChange}
        >
          {title}
        </Checkbox>
      );
    }}
  </Field>
);
